import { useMemo } from "react";
import { useParsedRecords } from "@/portals/patient/context/ParsedRecordsContext";
import { adaptMedication } from "@/features/patient/medications/utils/adaptMedication";
import type { Medication } from "@/shared/types";

interface MedicationsResult {
  medications: Medication[];
  isLoading: boolean;
  error: string | null;
  refresh: () => void;
}

// Derived from ParsedRecordsContext (which already fetches every resource
// type unfiltered) instead of its own independent fetch — MedicationRequest
// is a strict subset of that same data, so a second API call here was pure
// duplication. No Provider needed: this is a pure selector over the one
// real fetch/loading/error/refresh state that ParsedRecordsContext owns.
export function useMedications(): MedicationsResult {
  const { records, isLoading, error, refresh } = useParsedRecords();
  const medications = useMemo(
    () => records.filter((r) => r.resourceType === "MedicationRequest").map(adaptMedication),
    [records]
  );
  return { medications, isLoading, error, refresh };
}
